import { render, staticRenderFns } from "./shippingInfoQA.vue?vue&type=template&id=4ffe7282&lang=pug"
import script from "./shippingInfoQA.vue?vue&type=script&lang=js"
export * from "./shippingInfoQA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports